import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tamr-icon-checkbox-unchecked",
  "use": "tamr-icon-checkbox-unchecked-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"tamr-icon-checkbox-unchecked\"><path d=\"M30,2V30H2V2H30m1-2H1A1,1,0,0,0,0,1V31a1,1,0,0,0,1,1H31a1,1,0,0,0,1-1V1a1,1,0,0,0-1-1h0Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol